import React, {ReactElement, useState} from "react"
import Grid from "@mui/material/Grid";
import {Group} from "../Group";
import {Button} from "../../../../App/components/Button";
import {IGroup} from "../../../../Account/interfaces/group";

interface Props {
  onClose: (code: IGroup) => void
}

export function Create(props: Props): ReactElement | null {
  const { onClose } = props
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <Grid item>
      <Button
        size="large"
        type="button"
        onClick={handleOpen}
      >
        Добавить
      </Button>
      {open ? (
        <Group
          open={open}
          onClose={(group?: IGroup) => {
            if (group) {
              onClose(group)
            }
            setOpen(false);
          }}
        />
      ): null}
    </Grid>
  )
}
